import React from 'react';
import { Dialog } from '@headlessui/react';
import { IoCallOutline, IoLogoWhatsapp } from 'react-icons/io5';
import { MdSupportAgent } from 'react-icons/md';

import BaseModal from '../../components/BaseModal';

type CallSupportModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

function CallSupportModal({ open, setOpen }: CallSupportModalProps) {
  return (
    <BaseModal isOpen={open} onClose={setOpen} width="w-[560px]">
      <div className="p-2">
        <Dialog.Title
          as="h3"
          className="text-lg font-semibold leading-6 text-gray-900"
        >
          Contacta con nosotros
        </Dialog.Title>
        <p className="mt-2 text-sm text-gray-500">
          Estamos aquí para ayudarte. Contacta con nuestro equipo de soporte o
          ventas de lunes a viernes de 9:00 a 19:00.
        </p>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="rounded-lg border border-gray-200 p-4 flex flex-col items-center text-center">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 mb-3">
              <IoCallOutline className="h-6 w-6 text-blue-600" />
            </div>
            <p className="text-sm font-medium text-gray-900">Soporte</p>
            <a
              href="tel:+34910886005"
              className="mt-1 text-sm text-gray-700 hover:text-blue-600"
            >
              +34 910 886 005
            </a>
            <a
              href="mailto:info@swipoo.com"
              className="mt-1 text-xs text-gray-500 hover:text-blue-600"
            >
              info@swipoo.com
            </a>
          </div>
          <div className="rounded-lg border border-gray-200 p-4 flex flex-col items-center text-center">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 mb-3">
              <MdSupportAgent className="h-6 w-6 text-blue-600" />
            </div>
            <p className="text-sm font-medium text-gray-900">Ventas</p>
            <a
              href="tel:+34910886005"
              className="mt-1 text-sm text-gray-700 hover:text-blue-600"
            >
              +34 910 886 005
            </a>
            <a
              href="mailto:profesionales@swipoo.com"
              className="mt-1 text-xs text-gray-500 hover:text-blue-600"
            >
              profesionales@swipoo.com
            </a>
          </div>
        </div>
        <div className="mt-4 rounded-lg bg-blue-50 p-4 flex items-start gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-green-600 shrink-0">
            <IoLogoWhatsapp className="h-5 w-5 text-white" />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-900">
              También por WhatsApp
            </p>
            <p className="text-sm text-gray-600">
              Escríbenos al{' '}
              <a
                href="https://wa.me/34623808656"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-blue-600 hover:underline"
              >
                +34 623 80 86 56
              </a>{' '}
              y resolveremos tus dudas lo antes posible.
            </p>
          </div>
        </div>
      </div>
    </BaseModal>
  );
}

export default CallSupportModal;
